module.exports = __webpack_public_path__ + "static/logo-7249363487feb80632a41f5a2147e330.png";